<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'

const router = useRouter()
const route = useRoute()

function onLogin() {
  localStorage.removeItem('CHATBOT_MESSAGE_LIST_NULL');
  let { token, cwid } = route.query
  if (!token || !cwid) {
    console.log('参数错误，未经授权的访问')
    return
  }
  sessionStorage.setItem('token', token.toString())
  sessionStorage.setItem('cwid', cwid.toString())

  window.location.href = `/mobile/#chat`
  //跳转到首页
  //router.replace('/chat')
}

onLogin()
</script>

<template></template>

<style scoped></style>
